import React, { useState, useContext, useEffect } from "react";
import { LTabStrip } from "@loffa/gpp-modules";
import { ClientTemplates } from "./ClientTemplates/ClientTemplates";
import { LoffaTemplates } from "./LoffaTemplates/LoffaTemplates";
import { AuthContext } from "../../../../../context/AuthContext";
const GATEWAY_BASE_URL = process.env.REACT_APP_API_GATEWAY_BASE;

function TemplateManagement() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [loffaTemplates, setLoffaTemplates] = useState([]);
  const authContext = useContext(AuthContext);
  const token = authContext.authState().accessToken.accessToken
  const requestUrls = {//urls passed into the FileMapper UI module - dynamic URLs are used for future client-facing implementation
    gDataManagerTemplateOptionsUrl: GATEWAY_BASE_URL + "/datamanager/api/Template/DataTemplate/",
    gDataManagerTemplateMapperTransformationsUrl : GATEWAY_BASE_URL + "/datamanager/api/Template/TransformationOptions",
    gValidTemplateHeadersUrl: GATEWAY_BASE_URL + "/datamanager/api/Template/DataTemplateColumn/Template",
    gFetchCustomDataManagerTemplates: GATEWAY_BASE_URL + "/datamanager/api/Template/DataTemplateUserMaps",
    gSaveCustomUserTemplateMapper: GATEWAY_BASE_URL + "/datamanager/api/Template/TemplateMap",
    gValidateGridDataUrl : GATEWAY_BASE_URL + "/datamanager/api/Template/Validate",
    gClientDataManagerFileTemplateMapperInitUrl: `/api/Template/AdminPortal/ReactClient/TemplateMapper/Init/${authContext.userInfo().loffaUserGuid}/`,
  };
  
  const fetchLoffaTemplates = async () => {
    try {
      const response = await fetch(
        `${GATEWAY_BASE_URL}/datamanager/api/Template/DataTemplate/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) throw new Error("Failed to fetch Loffa Templates");
      const result = await response.json();
      setLoffaTemplates(result);
    } catch (error) {
      console.error("Error fetching loffa templates:", error);
    }
  };
  useEffect(() => {
    fetchLoffaTemplates();
  }, [authContext, token]);

  return (
    loffaTemplates && (
      <div>
        <LTabStrip
          selected={selectedTab}
          onSelect={(e) => setSelectedTab(e.selected)}
          orientation="vertical"
          tabPosition="left"
          tabs={[
            {
              title: "Client Template Maps",
              body: <ClientTemplates loffaTemplates={loffaTemplates} requestUrls={requestUrls}/>,
            },
            {
              title: "Loffa Templates",
              body: <LoffaTemplates loffaTemplates={loffaTemplates} fetchLoffaTemplates={fetchLoffaTemplates}/>,
            },
          ]}
        />
      </div>
    )
  );
}

export { TemplateManagement };
